<div class="row align-items-center justify-content-center">
  <div class="col col-xl-6 col-lg-8">
      <app-cards-basic title="Register"
                       description="Please complete the form below to create a new account. Fields marked with an * are required."
                       [loading]="isLoading">
        <form (ngSubmit)="register()" [formGroup]="registerForm">
          <!-- E-Mail -->
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Email" required>
            <mat-error *ngIf="registerForm.controls.email.invalid">
              Please enter a valid email.
            </mat-error>
          </mat-form-field>
          <!-- Mobile Phone Number -->
          <!--
          <mat-form-field appearance="fill" class="w-100" style="display: none">
            <mat-label>Mobile Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" placeholder="Mobile Phone Number" required>
            <mat-error *ngIf="registerForm.get('phoneNumber')?.errors?.['phoneNumberInvalid']">
              Please enter a valid phone number with country code. Valid Format: +41791231212
            </mat-error>
            <mat-error *ngIf="registerForm.get('phoneNumber')?.errors?.['phoneNumberInvalidCountryCode']">
              Please enter a telephone number with the correct country code. Valid Format: +41791231212
            </mat-error>
          </mat-form-field>
          -->
          <!-- Password -->
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" placeholder="Password" required>
            <mat-error *ngIf="registerForm.controls.password.invalid">
              Please enter a password.
            </mat-error>
          </mat-form-field>
          <!-- Confirm Password -->
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Confirm Password</mat-label>
            <input matInput type="password" formControlName="confirmPassword" placeholder="Confirm Password" required>
            <mat-error *ngIf="registerForm.hasError('mismatch') && registerForm.get('confirmPassword')?.touched">
              Passwords do not match.
            </mat-error>
          </mat-form-field>
          <button mat-flat-button
                  color="primary"
                  type="submit"
                  class="bp-button bp-button--large w-100"
                  [disabled]="!registerForm.valid">Register
          </button>
        </form>
        <p class="pt-4">Already registered? <a [routerLink]="['/login' | localize]">Log in here.</a></p>
        <app-alerts *ngIf="alertData" [alertData]="alertData"></app-alerts>
      </app-cards-basic>
    </div>
  </div>
